import type { IconNode } from '../types';

/**
 * @name coins-stack
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8ZWxsaXBzZSBjeD0iMTIiIGN5PSI2IiByeD0iOSIgcnk9IjMiIC8+CiAgPHBhdGggZD0iTTMgMTBjMCAxLjcgNCAzIDkgM3M5LTEuMyA5LTMiIC8+CiAgPHBhdGggZD0iTTMgMTRjMCAxLjcgNCAzIDkgM3M5LTEuMyA5LTMiIC8+CiAgPHBhdGggZD0iTTMgNnYxMmMwIDEuNyA0IDMgOSAzczktMS4zIDktM1Y2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/coins-stack
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const coinsStack: IconNode = [
  ['ellipse', { cx: '12', cy: '6', rx: '9', ry: '3', key: 'euc5yo' }],
  ['path', { d: 'M3 10c0 1.7 4 3 9 3s9-1.3 9-3', key: '19892i' }],
  ['path', { d: 'M3 14c0 1.7 4 3 9 3s9-1.3 9-3', key: 'dfoqgr' }],
  ['path', { d: 'M3 6v12c0 1.7 4 3 9 3s9-1.3 9-3V6', key: '277pzx' }],
];

export default coinsStack;
